import { render, staticRenderFns } from "./BlockAxt.vue?vue&type=template&id=725803a5&"
import script from "./BlockAxt.vue?vue&type=script&lang=js&"
export * from "./BlockAxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports